{
  "season": 1,
  "episodes": [
    {
      "episode_number": 1,
      "title": "الحلقة 01",
      "duration": "45m",
      "thumbnail": "https://raw.githubusercontent.com/elhizazi1/filerawanui/refs/heads/main/Haw/Ep01.webp",
      "video_source": {
        "type": "external",
        "source_id": "hob-aa-waraq-s1e1",
        "protected": true
      },
      "watch_token": "LPSEdm8VkLgfodcO-uCH1ENfYcRa_q1BZtes_NiQ8wnBE3Y0cFWWNSGzVMABev7BMMj5pI4LlSQtttN_KBiWcJ6yEGsRVSE2IqFY_7I-A8YtxD0JQKHNTDsTjlo7-DfEs-eoz4qPeWTrV-c-QM08XJ3Yh7X7RfS0XMUrZKXEvBz8oj3snz6QaeoqTfzqBfP0qygLgPft__CgXUnNQ8tAGeMu6RVQ8MMQfInieJQUntsmGDOCqjtXSYfQI8sx-JGsIt0Hcc4mBPzTSuKldCtveahvysPhfHvbQHcrMyagL8HhDo1JSV6KfJl6Mg_xhhyLsuDBH00N8ULLRsObmJEJXuv47eCUnF2gI45QH9Pp6ajkw3dDy7LJYEI8_eETip07-6L5M2wtGbgEsKzsY3iTQVMRJ0OOQp02bZHw5Z3D9qpgeiw"
    },
    {
      "episode_number": 2,
      "title": "الحلقة 02",
      "duration": "45m",
      "thumbnail": "https://raw.githubusercontent.com/elhizazi1/filerawanui/refs/heads/main/Haw/Ep02.webp",
      "video_source": {
        "type": "external",
        "source_id": "hob-aa-waraq-s1e2",
        "protected": true
      },
      "watch_token": "1pMOsnYQ53AgvP-le_aIb1zYep3zJknxrmhTX7TCAiAQTtYetblhjaV-hPqeJWQsb-BJezX0jzHIYonXeGL7zFnYx-9Ib5UYphTDaTQuWLIdSx_OV82xeDqHm9M2v0mV1uCWlalgdXDD0BcOo4QQomQfCzchrr2B24dQq7n7Xnbf0_qn5-YP6jSCyhLwkXqDgJNQDq3bAryhVxNvWj0-JQsBRXsqIbyEuT24nqegzDQC7tOy1B1f4BU3AWDsQIHGf68Yt1Y87F0XCtstcMV4RS38wcIxeseLAShSHJlja9zIt2O1xfSOUpiK7jT6iBG0hTU8mfdN5u3IinRGmhxl5JNYRvvSd-z1lmsdGsjTqVYwm4HQgKRTuvlAJE2lWIfRA1c5ij1RVZW3OERhMqKHvXbgARSNAAy9fsWQkMR5Zg2n3kk"
    },
    {
      "episode_number": 3,
      "title": "الحلقة 03",
      "duration": "45m",
      "thumbnail": "https://raw.githubusercontent.com/elhizazi1/filerawanui/refs/heads/main/Haw/Ep03.webp",
      "video_source": {
        "type": "external",
        "source_id": "hob-aa-waraq-s1e3",
        "protected": true
      },
      "watch_token": "29HOlkxyG0w8p4-eQteWqbMF6tX86YsYPDDBfv_F09xtmKc86bRCQ8RKDm5caMcvQbkj_XHVg9AuFGv7tU8NoYyJ2kQZQNpIJ4FAcRY0p529fB8aU997RX2aT4fO2A3IZe3DYbnPqpUshGOIuIMvvu0ytzGxnFGchoH0Ud7alOwzWdvgH2C3SDs8Mo49_R3M24xUUdUB9-392hl9w_YuKQxZwdK0nYlf8r1LzEPIpt3SxRDaVUi_sNpnPhxKN1mjw5fF9jLS1joULrYM_v1CfiIHWj5SYl2feat0sDU0pr5_7BStpGRpxyFhxYM8eyt_Iu_L3DXoKU-6rUmAuUAm6rhbetbYvw5K6rxzl1_0Wn1Hhvkd4Lu8E0QBOCZz2x29zkT7AjQ0yMpy4uFQNepj1tvRZ0_f4dZR0fhdTfzYgU0jYA"
    },
    {
      "episode_number": 4,
      "title": "الحلقة 04",
      "duration": "45m",
      "thumbnail": "https://raw.githubusercontent.com/elhizazi1/filerawanui/refs/heads/main/Haw/Ep04.webp",
      "video_source": {
        "type": "external",
        "source_id": "hob-aa-waraq-s1e4",
        "protected": true
      },
      "watch_token": "NAJ3Ya7m4yYcH5gB2xOcW71UNwVOnCf9hVQYhYBNR3F4e-z6ttxPgBFu7JwsRXgxdy_wz9ytdBcEjRQtp7Xxtarqu9smqJotgOX70YqbwPVQ1CmNTAxESBFtDdnoFImLGB6yYXxQx22UfsVlu7nnUydlYlQQzyjiCqkTikgBv5IUHEyDOGLgiSwfHePzrKqip3tKKKEBJDVMIB1x0_Y29bAf4imVlJZw41Ns4vBApiQzYN_a5LRO4yq8RORFf443ljobrpA4xboZOBiXAUM1Gbi6Y_0jtzKdni4d1RNtWgljZgWWyqpxwQw601S6dI4wY5_NDl3yz3r31FpN5ugiYpjwpXZh-WzemVAeISUZ1nUmZ8R8c7s5rQNAaZGMLf9jIHovQ_E7LdWT6BO1IAEpPlD58T3jxE3qVpkjjJVT8GM"
    },
    {
      "episode_number": 5,
      "title": "الحلقة 05",
      "duration": "45m",
      "thumbnail": "https://raw.githubusercontent.com/elhizazi1/filerawanui/refs/heads/main/Haw/Ep05.webp",
      "video_source": {
        "type": "external",
        "source_id": "hob-aa-waraq-s1e5",
        "protected": true
      },
      "watch_token": "Nj7KBde2pvWshmgZ344PZmnXQnrY3E-wlhmU8M3Lt6tDGpKes2msAe22qg5b1CTCcY-MvpzOVxhzlRQFgBncIUH1nw8aJHAyq0nTzezWfAWBzzpiBt2tIDwt4A1kMgUFSYIRnjLmcJHPK6xyW8-rg-TxG1619PTAag-X83G0exXJOzNUdoG8SFlg4x0KTogCVAihuztiI-mK1TtHgYGBUIMinW9DC85_xMg2Fjg437M2RQ22qTMpQsvbCClLMZZTzlIGscovd1g2oE8pHU3axRIzXFC3awh-DmG4V5VRvMu1lPh8eWiWSlpSTKRmqcTs6ad2NOAl5rhgkAUxLoEO60W6Sitke9EC22GNxhIFDCUTl7noxsyiwI_x_LVWKf21oHxAAYcoj4TAHAJX5xFkmopfNaRDbZ67-Fk5pG0bSTuHtG9M"
    },
    {
      "episode_number": 6,
      "title": "الحلقة 06",
      "duration": "45m",
      "thumbnail": "https://raw.githubusercontent.com/elhizazi1/filerawanui/refs/heads/main/Haw/Ep06.webp",
      "video_source": {
        "type": "external",
        "source_id": "hob-aa-waraq-s1e6",
        "protected": true
      },
      "watch_token": "Y4COlgrzIKmxJYyT8X9QCFZUqZntQQQbBdcpuCFZ1xIyZb6_U7TcEpdTuzjoUrMZbZxP9igGDVoi5dvUpAv2PAIy9Oy5p2EuqP7cZtaBhY9FtUii1lah8tuNBNalcEE-4-t4kuyHwpr-cpFJqVJMw4d9M4jG8ya-RShukVB8L4XE1b9OnjodsLxhVbI-3Wgoiy1yxQt9IYwcDrV_7HF6h6dzH9_00LpVBXfgeANZamnckNsB6TNDXU2ASTo-wTlAlfZNCajMK07rMoAP64KkRXLKX-6DaJWBXxrJWk5_Z9W6F6SE7_BG7wtd23eps1bdK4KBS_iIqX3UJo1DNGKQP1K7ZpcBUctqKaFMPNFun12BUgaRyPyHXqNDcXL88vhf_8IkGZEu8LW9RJ1wUZTi58-af0h6z-HKm8OFO9Z5h-Rv2V8"
    },
    {
      "episode_number": 7,
      "title": "الحلقة 07",
      "duration": "45m",
      "thumbnail": "https://raw.githubusercontent.com/elhizazi1/filerawanui/refs/heads/main/Haw/Ep07.webp",
      "video_source": {
        "type": "external",
        "source_id": "hob-aa-waraq-s1e7",
        "protected": true
      },
      "watch_token": "rb76WdgpPn6Msak_kw0n3BGqsEvnX52uHLU9MsvBg7odFUZW786YUoV5dboVhG9B5WUOjf-gELnumDjNvl2fymlQcFxFp41uK0zg3YgjXV7hKdZXhqkoSQ-_Kz7jcgm9-PZBCI1iCJqcQt9E0YovC8u0bJ9s0NrRdv5itX_sRxVO-rg2DEGPN2RWLXX2TaB-DmCwr3PcM7hMkgArnokcFoF02sKBOefySG02HEwgpXiY0xb9AUM2oL5xzrkoOTjmp3YtDQmZBoSGMRdcg6xcyhGc6kFpJ10qQFc2fqTj-ESGzS1Wbx2VPWbKABNtDrw6U55ldUNfjnCoUaROfQkjWNUwfLkrrfd-5_fH1ZTb112zw02p2wR7OIv4fyvxkiO9jnhQirJKj6L1FlMORo7Nl9Fy_sLfGGuJMr0xEEb3xmMAnfA"
    },
    {
      "episode_number": 8,
      "title": "الحلقة 08",
      "duration": "45m",
      "thumbnail": "https://raw.githubusercontent.com/elhizazi1/filerawanui/refs/heads/main/Haw/Ep08.webp",
      "video_source": {
        "type": "external",
        "source_id": "hob-aa-waraq-s1e8",
        "protected": true
      },
      "watch_token": "z3fn3prEOH7XKX9L3ksjxEAKkx5BpPDgriUn9eH8VeO5CEKFM7JakAlMuQNoaSjOnDI6Fuvd1hQmc9scWmV2QSLFt_7wKgUKKzXllKiG77w5QLqsKhUsgIwCRctfSirEcck_iGJ1Cs1CJfzQu-hzmNRit8u5EQaoA_b3qK6P6_khTyloRgBmIsQ1TmMPCQCBsYnbvA99t9nnSIePB0mduJifhJzxkfIALUsCtiuTjhpuHlrPmR9b3ixF7p9bxT9LbNtc5fTHCFmeDIMUCEx0Pt7wYeyVrhEBNF9AJLzOfuCvIst4JcR8HZTcBvBGy3C6NwIYkVsg_zMjDcLM7sxbbUrjBLFhC7cBRI8dSzaTEuAZ814da2IyiE37v9JGrOvQJhU3qXSSDEYfNohQIJDCdH6hHDR7xRV_cLHDXjyR0VkJLrM"
    },
    {
      "episode_number": 9,
      "title": "الحلقة 09",
      "duration": "45m",
      "thumbnail": "https://raw.githubusercontent.com/elhizazi1/filerawanui/refs/heads/main/Haw/Ep09.webp",
      "video_source": {
        "type": "external",
        "source_id": "hob-aa-waraq-s1e9",
        "protected": true
      },
      "watch_token": "ltvqnZOXs_SSVf8bzjC1iFmDPuODLWPN4Wctn68YlrbAwRzt9d7FFXG0y0hUKyaQl98-Cme1MV3VKKUUdHeIy12JpqSIEdkqZWg1LWXjg_P0KV2YNRSMTtkIlMCKrOMJQ15nA2vLLkx_oaloHLUqM5Pqt8InJ3adzzDD3zLHnEQMnw5ofacMJwISJTbgFia9acIOMbOyyhvdnRYNdb9ZAsaKYIZI_IkAchlXtGAFCLCgY4_NfK8u6DqRkzQdBs30qLmD_bgI5hJBVwgVvWmBZi7btrWhWaK1Kam-j9_cyVb0DRLy5k3CanHQF3KvAr_sKUA41C3CVnLYNRDkpdPiULBCuLjWtZq4JDqU4AM4wLstBkCcQjKwx0D5PftNS-QCzwqqfm7AyTF5rT4rjk18naKtmJi5ol1_DzuPvwStQNeusZc"
    },
    {
      "episode_number": 10,
      "title": "الحلقة 10",
      "duration": "45m",
      "thumbnail": "https://raw.githubusercontent.com/elhizazi1/filerawanui/refs/heads/main/Haw/Ep10.webp",
      "video_source": {
        "type": "external",
        "source_id": "hob-aa-waraq-s1e10",
        "protected": true
      },
      "watch_token": "ltO88Az5hhtMy2cdeSFXt46GNW-KwtOuf2ObQgJOpyOlrh_l_fVHkOLtc2va4JtmIIOND5bGkLnRdi5hAm3V4YTddhCuvHR8L2hvVk3IfeebqgcgVgBxttyTX_rMBLtZnDLUldF9dM8pEAf1bWNF4GO_zlZ9QqI4HeWc8dUg1uqfiiKX2rm47QL6vxf7rDJ29UrDjXwSXkCgJmfbNQ1Hn3GQLXRfufI1oz_439Ua_-jSWch7Aj6PKRVYIaDX77cIavDpGe-zPAhUQQNN47LxF9F_WcpV5zme3WP2X66ys2HPM5G_VQ_ZrWMDSkDsthLOplNFxbIhJlL8gZzUqRENUPJGBhlCnsMTek3XBk9GoGelq0Q7a5lXHCaSsTEKmxi488VFNl-Dm0zMyVLdDg4hlCq8ZxBpEo77Vw9txR4fxoTLCg"
    },
    {
      "episode_number": 11,
      "title": "الحلقة 11",
      "duration": "45m",
      "thumbnail": "https://raw.githubusercontent.com/elhizazi1/filerawanui/refs/heads/main/Haw/Ep11.webp",
      "video_source": {
        "type": "external",
        "source_id": "hob-aa-waraq-s1e11",
        "protected": true
      },
      "watch_token": "4vt2nGGcrUeHsEaI_qKqz6a6mz9N6_jqKu-b72KOATJth-e8Q8MzFJrGOaglxH3NF6N3B5oYxgDkPKnCvNTFrFbjeW20mmqxQS65xj5co-YCHmqLD_-32dbMTfa_Sr0IEXiAsZ1_oQtylVKPCldcJCvtTivW6x4ED6WdeicYVeF4Rhh1Ew6Ik-SdnQXpSn0W6ICFOzEZ6FDoYcpB5LTa2LTHwAC5Wp44vUmIcoBiFx9FwxPIFfwMMsRJeI0h43MXUYU1MVMEQFW9zGF3vW6JPV4OqkQXCtc2wuhJv17EKmOOwM2PismB79u1jqmmOncjsOvLb4KZzIPj7mVXmn0PaY8yuqnse8WMerJ_TPdTens7WL7mi-TaV9RU7siYFjzjOrGoO6PRv6EGXWbqIxIHywWDWKrbsuZvB57XzhuysqE7msLe"
    },
    {
      "episode_number": 12,
      "title": "الحلقة 12",
      "duration": "45m",
      "thumbnail": "https://raw.githubusercontent.com/elhizazi1/filerawanui/refs/heads/main/Haw/Ep12.webp",
      "video_source": {
        "type": "external",
        "source_id": "hob-aa-waraq-s1e12",
        "protected": true
      },
      "watch_token": "ZynycwPr1b_7gYUzdldfERqXioEUUuiquCb1YYkGj9J7IlNtIK1eujPkQSPT4spsQR6vREa0wBZ1FS9UqYeYm8BkaoIhSNb-5pXOThDqa6iBsvf1fg1PP04ewPoz0b92kaercefi-z6i7yjQS4GLlHDimGoClfpG8FiOHO13B9RvIitMHPLLlJxCgd4woFxy8LuSD9fLA5oddfR5nealOnKuNdwfUYSdnlIdyVJ48oOJDAVGbFIlH7oXKfZlSqUlbuX0XNFvYE7UZto5MpVL0SV9Cv6lPwTrS2C1zRV_t9MxLhKku8uKMmZY3iHDnPksKaogTVNnnIBJ43FlUgO_XeUBh2e3ypdfS7djhMPRvSPGWuwa7unkZobPsViLTFTv48rrb3KSdrPhEEg0DWM80q6q_zLX4cB0Dq_PCeqEXT0f_I8"
    },
    {
      "episode_number": 13,
      "title": "الحلقة 13",
      "duration": "45m",
      "thumbnail": "https://raw.githubusercontent.com/elhizazi1/filerawanui/refs/heads/main/Haw/Ep13.webp",
      "video_source": {
        "type": "external",
        "source_id": "hob-aa-waraq-s1e13",
        "protected": true
      },
      "watch_token": "sDP6kjudvGIuDXiRqIfL34HIzRzL6szz5pMv6_EjFcQ9n-b_6-3d3zMBH3Tmpm41JUkR8gFpA-fYre-tgcpNpTgqQC4dyWKtNQPZUiXxzX09_fVz4CNkjGMWleZEWgnaxQOHR78yBqiittIUeq97L5cDxSB3u4UpNMd3CissBrFg7eRSX1WBNMez9eB1RxfxjlL_Dbdb3pSd5dMwudZKktL8xp6orv5iWm4T5Rr5bSti8Da5eYlkcRaQ8uhh7yR-D5fV_TOO5LqtFvnHgODAxTqbhp_J4ylI7-rFcjcxM8Xre_QGBkLIImi_TuD1XXeapOsX3uUdV2cxRdY_6UtO17I7Ec2u0f8mv3895Kzh7azkv_x6yFcpp7PMCGaGVyhi3Pr-oEMRg5bEyNx6pSba7w_AIcldA46lWYO3kWWCAVDqy30"
    },
    {
      "episode_number": 14,
      "title": "الحلقة 14",
      "duration": "45m",
      "thumbnail": "https://raw.githubusercontent.com/elhizazi1/filerawanui/refs/heads/main/Haw/Ep14.webp",
      "video_source": {
        "type": "external",
        "source_id": "hob-aa-waraq-s1e14",
        "protected": true
      },
      "watch_token": "3X4w_Vrm99c3xt-q-iwM1R0J19R1xhkQWdA-_1-ZUqa-tvnHf6rM_7uoEz7tym59pBCxBn3Pm3q9qHIz_9YUbNiHLzhuOwT_To1DMO6_o1fD1vrMKXFN0Vz6_nfCHoxlq5_J037VA7yyTJgfxYUGUitGYvk5nYrkjsJ61yZJfZ63yJe3bCCtyNaloxdfQ74nWGbhVO9Pzztb85IzmuEVF8yueR3waHgG8ERXfkNb0gZKhOMLMqPdrP66BRBlrrVNBpdMS4e17YDTMDBUBoiBWu5eaFm0mde675Myy6Bo-Neh1MszmM0uMeMoWgxjSu2iffPseN0llz_wSQWCzY5uPG8FvbzfSOFCmsfeS7VQzkzeaS8myy0eXMDAAaVUliFCSY7Reyt7whIZA5yx1AnRcB6Z1rkJmCHsrtUbwIugysCOWEY"
    },
    {
      "episode_number": 15,
      "title": "الحلقة 15",
      "duration": "45m",
      "thumbnail": "https://raw.githubusercontent.com/elhizazi1/filerawanui/refs/heads/main/Haw/Ep15.webp",
      "video_source": {
        "type": "external",
        "source_id": "hob-aa-waraq-s1e15",
        "protected": true
      },
      "watch_token": "0gkNHUb6RepBd2cj3juT7lA4xvc4RK6aimwpHEiTRvcfFJlZ5shwxaT9yaaKcT2d0CIizvC_vXFnUWm1WwjIxvTrRfEIXSUjrPjU22VraEh1Zf5Rh7alX_a9TrHauJzvQwjbu4G-deFxS57BrV_LNlSMZAA49rWry8aLe2x_j5GKcB3uuD8TLVf3o_Egw74Lsc4Z9qawF4WKiTQSiMxyijAjfjflxdz0U7LRoSNFtRtFnql5CpA6dZrvK1IZP_43Bnu8mDfLFpsLrF9aQQrP7CilIQlyiTRZnU-nYn2l8_SNLvblkFKSkMPrGRp-KEgysoabLeS8icA34R-CPDevXecTO_uuemqaMONh3ho8JGjm7qIasjh9sS2cHv4hm8oZP6qrg1jjbrPtpvUx9otr3nsI0pl9XHGOwmHCzJEswUr575o"
    },
    {
      "episode_number": 16,
      "title": "الحلقة 16",
      "duration": "45m",
      "thumbnail": "https://raw.githubusercontent.com/elhizazi1/filerawanui/refs/heads/main/Haw/Ep16.webp",
      "video_source": {
        "type": "external",
        "source_id": "hob-aa-waraq-s1e16",
        "protected": true
      },
      "watch_url": "https://rawan.elhizazi.me/play?t=urDxAp1y-r-fhsEHQ4gUYf5LtOxI-N0COQ6kwc5fIGhImBybnkkcF9hkb0m50GDwBHZNSt7RX965EsJUQ2_n5r3c0uzn0xLSArDojykvOX_uOUk5hFu_QUhOYVolFD_XnJlg70soB51SxsSyyH_6PkmNCWOXCijjP_kEEmthEBYSA0VYNCieKsdxu7LdRXgSNFHMiAqbHCieuOIyozA17kkHlvZq9HjfsIGn4mcuSFApWgzn3ktoaMsX9v1fQ6AB0Ju6Il-XSglE_hDSEYGNv3AcKXXfbU2gFRcVEaYI6c3TKCzEyXbbw0OjCE5_zar0VwHvJy1ly9Knc0vghrFP4RH0KRzHPyKPoyy4f6Cz0Q7S4TTjCw1MEVRghzcDhnv0L9YMvsX1RIexrD7KmzO9NOSsDuFRh-9Rw1_Z12H8eoddA7D9N8RkLFydMw&kind=series&slug=hob-aa-waraq",
      "watch_token": "urDxAp1y-r-fhsEHQ4gUYf5LtOxI-N0COQ6kwc5fIGhImBybnkkcF9hkb0m50GDwBHZNSt7RX965EsJUQ2_n5r3c0uzn0xLSArDojykvOX_uOUk5hFu_QUhOYVolFD_XnJlg70soB51SxsSyyH_6PkmNCWOXCijjP_kEEmthEBYSA0VYNCieKsdxu7LdRXgSNFHMiAqbHCieuOIyozA17kkHlvZq9HjfsIGn4mcuSFApWgzn3ktoaMsX9v1fQ6AB0Ju6Il-XSglE_hDSEYGNv3AcKXXfbU2gFRcVEaYI6c3TKCzEyXbbw0OjCE5_zar0VwHvJy1ly9Knc0vghrFP4RH0KRzHPyKPoyy4f6Cz0Q7S4TTjCw1MEVRghzcDhnv0L9YMvsX1RIexrD7KmzO9NOSsDuFRh-9Rw1_Z12H8eoddA7D9N8RkLFydMw",
      "download_url": "[{\"quality\":\"720p\",\"url\":\"https://rawan.elhizazi.me/safelink?t=raTA4bFUZQpeSevVOilTbetO4ZGSWI6Y5sU9BpaRUpMq2CA0WiHO2JsyVLK-j-J8SNUdsLA9Cjt09TdxlvYj8J12leei_A3aTTck6ypWWbQVNB9x6c8WyTkF3un3oyRS1Hz1QUZGTaSu--ENnRtozu6Gnfkr0j0NSv8VMAIlus54gaUsMXicjP0D2tUXqkI8iQGhGXQGDd4pCY8qsgNeb3PVhuxTeNMDKsHQ0A&d=1\",\"size\":\"303 MB\"},{\"quality\":\"720p\",\"url\":\"https://rawan.elhizazi.me/safelink?t=pcDKZdavdYhoVeUX26WP375W7jaaL1AVJlArNTpvG1f3DT1-54Aca5zSP0n_muhb9nVbOQQpBvBxjiCAY58MekWFa4vG4nP851wnFYvJhM11TZSeU0_RHzAy61CyK90ntkwigZ4vI-Xe9OoQHllp6aC7Uqbk15FTzkA&d=1\",\"size\":\"303 MB\"}]"
    },
    {
      "episode_number": 17,
      "title": "الحلقة 17",
      "duration": "45د",
      "thumbnail": "https://raw.githubusercontent.com/elhizazi1/filerawanui/refs/heads/main/Haw/Ep17.webp",
      "video_source": {
        "type": "external",
        "source_id": "hob-aa-waraq-s1e17",
        "protected": true
      },
      "watch_url": "https://rawan.elhizazi.me/play?t=_nnlMSqS-4axec_4N9az5oFaGuUvDIiEUh7iOmx-e6ARdPibzdyQWlrLXfDlKda7-gGF_ItLE03Vc-ffBm4AWDWozaLW5Yqz1ABlwE1-XFleBGUVfxBFzkAOOAnTN2Q9_ljhLez8y5Mina_VxboFUXii95sPIwbQq4xTcm7NLReMTgNKrNHc3TXJMGGvPQTM8ux0UFfksB6iy61QLYJc_Osj9Fr0D4rztM7pUs8S_ZizrSaXd0tKw4ep5oZpu2ZPtUbg-uG89Z_cJjrGoWXWfehslk23ON_mnlKmH9KoU8oz1NW09E1pDXxznMkbCe2VSnQXoKm7rAhgrUTa71_9ApN4UVhzTkEBANnlwg6JO-ZXRr_fbFepNg8OJT39PK-G_VEdXUqldAtYby4YP5qcj0P7H855lva5Zu7aAdrQmKVn6q4&kind=series&slug=hob-aa-waraq",
      "watch_token": "_nnlMSqS-4axec_4N9az5oFaGuUvDIiEUh7iOmx-e6ARdPibzdyQWlrLXfDlKda7-gGF_ItLE03Vc-ffBm4AWDWozaLW5Yqz1ABlwE1-XFleBGUVfxBFzkAOOAnTN2Q9_ljhLez8y5Mina_VxboFUXii95sPIwbQq4xTcm7NLReMTgNKrNHc3TXJMGGvPQTM8ux0UFfksB6iy61QLYJc_Osj9Fr0D4rztM7pUs8S_ZizrSaXd0tKw4ep5oZpu2ZPtUbg-uG89Z_cJjrGoWXWfehslk23ON_mnlKmH9KoU8oz1NW09E1pDXxznMkbCe2VSnQXoKm7rAhgrUTa71_9ApN4UVhzTkEBANnlwg6JO-ZXRr_fbFepNg8OJT39PK-G_VEdXUqldAtYby4YP5qcj0P7H855lva5Zu7aAdrQmKVn6q4"
    },
    {
      "episode_number": 18,
      "title": "الحلقة 18",
      "duration": "45د",
      "thumbnail": "https://raw.githubusercontent.com/elhizazi1/filerawanui/refs/heads/main/Haw/Ep18.webp",
      "video_source": {
        "type": "external",
        "source_id": "hob-aa-waraq-s1e18",
        "protected": true
      },
      "watch_url": "https://rawan.elhizazi.me/play?t=rt2KWGwjkRo-kFCxyh9Py4FMyk_ejljDPLnAAt1XK4NwepkxpVLA9JUZQFgG5lgiZbSgaycFPoWCJoV0d_JHwxyzEj_qQudZGQfYepfKDNVRp8fix_dg2HAq4p1pvPO08aXMWJeSqzBUgB25HxVeupKqzQTr0PBgn9nEvI0jzghcyuXG-RHEMYJVb63SpxFMg2N76hzQxWM6Hg5xeTaYvjgun8P02njkTeWl0_POKbVRM_xBh2niG7NvtnfQdtM0zlBGpoLybZ4fUr3mXYnq8-VzLFb5FqhSMtn1wJeSMBkGGm0yj8_gJT1QQJKlXq3Lvq4tvNFs7ujvECDDKWcCn-kK1w&kind=series&slug=hob-aa-waraq",
      "watch_token": "rt2KWGwjkRo-kFCxyh9Py4FMyk_ejljDPLnAAt1XK4NwepkxpVLA9JUZQFgG5lgiZbSgaycFPoWCJoV0d_JHwxyzEj_qQudZGQfYepfKDNVRp8fix_dg2HAq4p1pvPO08aXMWJeSqzBUgB25HxVeupKqzQTr0PBgn9nEvI0jzghcyuXG-RHEMYJVb63SpxFMg2N76hzQxWM6Hg5xeTaYvjgun8P02njkTeWl0_POKbVRM_xBh2niG7NvtnfQdtM0zlBGpoLybZ4fUr3mXYnq8-VzLFb5FqhSMtn1wJeSMBkGGm0yj8_gJT1QQJKlXq3Lvq4tvNFs7ujvECDDKWcCn-kK1w"
    }
  ]
}
